var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-sorting flex"},[_c('div',{staticClass:"flex-1"},[_c('v-select',{attrs:{"list":_vm.list},on:{"change":_vm.selectChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('p',[_vm._v(_vm._s(item.name))])]}}]),model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }